import { Button } from '@ui'
import { navigate } from 'gatsby'
import React from 'react'

const LinkText = () => {
    return (
        <div
            css={{position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '24px'}}
           
        >
            {/* <Underline showLine={showLine} height='4px' /> */}
            <h2 onClick={() => navigate('/kontakt')} style={{cursor: 'pointer', textAlign: 'center'}}>
                Bereit für das nächste Projekt?
            </h2>
            <Button  text='Zum Kontakt' onClick={() => navigate('/kontakt')} />
        </div>
    )
}

export default LinkText